module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gl-68756f324152d0ada90caf6c823f6f86.svg";